// extracted by css-extract-rspack-plugin
export default {"column":"_32bfde56","title":"_db901580","list":"_51a9f762"};